import { STATUSES } from "@/lib/constants";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

export function StatusBadge({ status, className = "" }) {
  const s = STATUSES[status] || STATUSES.bozza;
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-[11px] font-medium whitespace-nowrap ${s.cls} ${className}`} data-testid="status-badge">{s.label}</span>;
}

export function StatusSelect({ status, onChange, testId = "status-select" }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex items-center gap-1 focus:outline-none" data-testid={testId}>
        <StatusBadge status={status} /><ChevronDown size={13} className="text-slate-400" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {Object.keys(STATUSES).map((k) => (
          <DropdownMenuItem key={k} onClick={() => onChange(k)} data-testid={`status-option-${k}`}><StatusBadge status={k} /></DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
